import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CompanionAuthProvider } from "@/context/CompanionAuthContext";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

import CompanionLayout from "@/companion/CompanionLayout";
import CompanionGuard from "@/companion/CompanionGuard";
import CompanionLogin from "@/companion/CompanionLogin";
import CompanionToday from "@/companion/CompanionToday";
import CompanionJobs from "@/companion/CompanionJobs";
import CompanionJobDetail from "@/companion/CompanionJobDetail";
import CompanionNewJob from "@/companion/CompanionNewJob";
import CompanionNotices from "@/companion/CompanionNotices";
import CompanionNewNotice from "@/companion/CompanionNewNotice";
import CompanionTodos from "@/companion/CompanionTodos";
import CompanionCalendar from "@/companion/CompanionCalendar";
import CompanionCrew from "@/companion/CompanionCrew";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public marketing site */}
        <Route element={<AuthProvider><Layout /></AuthProvider>}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
        </Route>

        {/* Website admin (existing) */}
        <Route element={<AuthProvider><Outlet /></AuthProvider>}>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Route>

        {/* Crew Companion app */}
        <Route element={<CompanionAuthProvider><Outlet /></CompanionAuthProvider>}>
          <Route path="/companion/login" element={<CompanionLogin />} />
          <Route element={<CompanionGuard />}>
            <Route element={<CompanionLayout />}>
              <Route path="/companion" element={<CompanionToday />} />
              <Route path="/companion/jobs" element={<CompanionJobs />} />
              <Route path="/companion/jobs/:id" element={<CompanionJobDetail />} />
              <Route path="/companion/notices" element={<CompanionNotices />} />
              <Route path="/companion/todos" element={<CompanionTodos />} />
              <Route path="/companion/calendar" element={<CompanionCalendar />} />
              {/* Admin-only inside companion */}
              <Route path="/companion/admin/jobs/new" element={<CompanionNewJob />} />
              <Route path="/companion/admin/notices/new" element={<CompanionNewNotice />} />
              <Route path="/companion/admin/crew" element={<CompanionCrew />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

// Outlet import for nested routes that need an AuthProvider wrapper
import { Outlet } from "react-router-dom";

export default App;
